<template>
    <div v-if="!cookieBannerShown && !tempCookieShown" style="display: flex; flex-direction: column; align-items: center; position: absolute; z-index: 999; width:100%; height: 100%; padding: 20px; background-color: white; justify-content: center;">
      <div style="margin-bottom: 50px;"><img src="@/assets/images/logos/LP_Full_Main.svg"/></div>
      <div style="display: flex; justify-content: center; align-items: center; text-align: center;">We use cookies and similar technologies to give you the best experience.</div>
      <a href="https://lifepassliveit.blob.core.windows.net/resources/cookie_policy.pdf" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; cursor: pointer;">Learn more</a>
      <button @click="setCookieAccepted" style="background-color: #223672; color: white; padding: 10px 20px 10px 20px; border-radius: 90px; margin-top: 20px;">Okay</button>
    </div>
</template>

<script>
export default {
  name: "CookieBanner",
  props: ["cookieBannerShown"],
  data() {
    return {
      tempCookieShown: this.cookieBannerShown,
    }
  },
  mounted() {
    
  },
  methods: {
    setCookieAccepted(){
      this.tempCookieShown=true;
      localStorage.setItem('cookieBannerShown', true);
    }
  }
};
</script>

<style>
</style>